/* Version: 3.5.149 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

var MinusIcon = function MinusIcon(props) {
  return /*#__PURE__*/jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: "20",
    height: "20",
    style: {
      width: '1.25rem',
      height: '1.25rem'
    }
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M17 8.75v2.5H3v-2.5h14Z"
    }), /*#__PURE__*/jsx("mask", {
      width: "14",
      height: "4",
      x: "3",
      y: "8",
      maskUnits: "userSpaceOnUse",
      children: /*#__PURE__*/jsx("path", {
        fill: "#fff",
        d: "M17 8.75v2.5H3v-2.5h14Z"
      })
    })]
  }));
};

export { MinusIcon as default };
